import React from 'react';

import { offset } from '@floating-ui/react';
import cx from 'classnames';

import aModalStyles from 'components/shared/AModal/index.module.css';
import modalStyles from 'components/shared/GlobalModalArea/Modal/index.module.css';
import Icon from 'components/shared/Icon';
import ArrowLeft from 'components/shared/Icon/icons/ArrowLeft';
import Text from 'components/shared/Typography/Text';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { useTooltipDialog } from 'hooks/useTooltipDialog/useTooltipDialog';
import noop from 'utils/noop';

import s from './index.module.css';

type Props = {
  onClick?: () => void;
};

function BackButtonWithTooltip({ onClick = noop }: Props) {
  const { isMobile } = useMediaBreakpoints();

  const generateTooltipDialog = useTooltipDialog({
    message: (
      <Text size={isMobile ? 'medium' : 'small'} type="brandon" isStrong className={s.messageContainer}>
        Entered information will be lost,
        <br />
        Are you sure you want to continue?
      </Text>
    ),
    options: [{ text: 'No' }, { text: 'Yes', onClick }],
    floatingOptions: { middleware: [offset(6)] },
    containerClassName: s.modalTooltipContainer,
  });

  return (
    <>
      <button
        type="button"
        className={cx(modalStyles.modalReturn, aModalStyles.returnButton)}
        tabIndex={0}
        onClick={generateTooltipDialog.toggleTooltip}
        ref={generateTooltipDialog.setReference}
      >
        <Icon component={ArrowLeft} width="2.4rem" height="2.4rem" strokeWidth={1.5} />
      </button>

      {generateTooltipDialog.TooltipDialog()}
    </>
  );
}

export { BackButtonWithTooltip };
